export enum HolidayLocationType {
    SEA = 1,
    MOUNTAINS = 2,
    LAKE = 3
}
